import { MapServicePoint } from '@/models/map-service.model';
import { TransformedMarkersData } from '@/models/markers-data.model';
import { getMapImageExtension } from '@/helpers/supportedBrowsers';
import { verQuery } from '@/helpers/assetsVersionForCache';

class MapService {
    config: TransformedMarkersData;

    points: Array<MapServicePoint> = [];

    hasWebpImages: boolean;

    constructor(mapConfig: TransformedMarkersData, hasWebpImages: boolean) {
        this.config = mapConfig;
        this.initPoints();
        this.hasWebpImages = hasWebpImages;
    }

    public setActivePoint(roomName: string) {
        this.points.forEach((point) => {
            point.active = point.roomName === roomName;
        });
    }

    private initPoints() {
        this.config.points.forEach((mapPoint) => {
            this.points.push({
                label: mapPoint.label,
                roomName: mapPoint.roomName,
                image: new Image(),
                default: mapPoint.roomName === this.config.defaultPoint,
                active: mapPoint.roomName === this.config.defaultPoint,
                floor: mapPoint.floor,
                position: {
                    top: mapPoint.position.top,
                    left: mapPoint.position.left,
                },
            });
        });
    }

    public getPoints() {
        return this.points;
    }

    private getImagePathWithSupportedExtension(path: string) {
        const extension = getMapImageExtension(this.hasWebpImages);
        if (extension === '.png') return path;
        return path.replace('.png', '.webp');
    }

    public getMapData(basePath: string) {
        const pathData = this.config.map.image.path;
        if (typeof pathData === 'string') {
            return [{
                path: `${basePath}${this.getImagePathWithSupportedExtension(pathData)}?${verQuery}`,
            }];
        }

        return pathData.map((d) => ({
            path: `${basePath}${this.getImagePathWithSupportedExtension(d)}?${verQuery}`,
        }));
    }
}

export default MapService;
